/**
 * Animation preset library.
 *
 * Each category lives in its own module; presets are plain data + a
 * `build()` that adds GSAP tweens for an element onto the shared timeline.
 * To add a custom preset, either append to a category module or call
 * `registerAnimationPreset()` from anywhere at startup — the panel UI
 * (tiles, live preview, settings inputs) is generated from the preset's
 * `category`, `defaults` and `paramsSchema`.
 */
import { attentionPresets } from "./attention";
import { colorPresets } from "./color";
import { customPresets } from "./custom";
import { drawPresets } from "./draw";
import { entrancePresets } from "./entrance";
import { exitPresets } from "./exit";
import { flipbookPresets } from "./flipbook";
import { microPresets } from "./micro";
import { morphPresets } from "./morph";
import { physicsPresets } from "./physics";
import { registerAnimationPresets } from "./registry";
import { spatialPresets } from "./spatial";
import { templatePresets } from "./templates";
import { textPresets } from "./text";
import { threeDPresets } from "./threeD";

registerAnimationPresets([
  ...customPresets,
  ...templatePresets,
  ...attentionPresets,
  ...microPresets,
  ...entrancePresets,
  ...exitPresets,
  ...textPresets,
  ...morphPresets,
  ...threeDPresets,
  ...colorPresets,
  ...physicsPresets,
  ...spatialPresets,
  ...drawPresets,
  ...flipbookPresets,
]);

export {
  animationPresets,
  presetsByCategory,
  registerAnimationPreset,
  registerAnimationPresets,
  supportsAnchorPick,
  supportsCustomPath,
} from "./registry";
export {
  CATEGORY_ACCENTS,
  CATEGORY_LABELS,
  CATEGORY_ORDER,
  EASING_OPTIONS,
  HIDDEN_CATEGORIES,
} from "./types";
export type { AnimationCategory, AnimationPreset, ParamSchema } from "./types";
export {
  definePreset,
  DIRECTION_SCHEMA,
  DISTANCE_SCHEMA,
  DEGREES_SCHEMA,
  kf,
  rad,
  samplePath,
  SLIDE_VECTORS,
  timing,
  WIPE_TO_REVEAL_DIR,
} from "./helpers";
